/*
  Trappbutiken – kampanjpris i JS (Wubs, Liam 2026-09-13).

  Ytor som bygger sina prisrader i JS ur Shopifys JSON – sökets rullgardin (suggest.json) och
  önskelistan (/products/x.js) – får aldrig veta vilka kollektioner en produkt ligger i, och kan
  därför inte fråga snippets/wubs-kampanj.liquid själva. De frågar det här i stället:

    WubsKampanj.direkt()          → { handle: procent } om indexet redan finns, annars null (synkront)
    WubsKampanj.index()           → Promise med samma karta (hämtar vid behov)
    WubsKampanj.pris(öre, procent) → kampanjpriset i öre, eller null när procenten inte gäller

  Kartan byggs av templates/collection.kampanj.liquid, som i sin tur frågar SAMMA snippet som
  produktkorten. Det finns alltså fortfarande bara en plats där kampanjreglerna står.

  ⚠️ Uträkningen är kortets: heltalsdivision i öre, avrundning till hel krona först vid
  formateringen. Ändras den i snippets/wubs-price.liquid måste den ändras här också.

  ⚠️ Cachen lever i sessionStorage i 10 minuter. Kampanjerna styrs av hela datum, så det räcker
  gott – men en kampanj som Tom slår på syns i sök och önskelista först när cachen gått ut.
*/
(function () {
  var NYCKEL = 'wubs:kampanj:v1';
  var LIVSTID = 10 * 60 * 1000;
  var karta = null;
  var lopande = null;

  function pris(ore, procent) {
    var pct = Number(procent) || 0;
    if (!(pct > 0 && pct < 100)) return null;
    return Math.floor(Number(ore) * (100 - pct) / 100);
  }

  function lasCache() {
    try {
      var rad = JSON.parse(sessionStorage.getItem(NYCKEL) || 'null');
      if (rad && rad.p && Date.now() - rad.t < LIVSTID) return rad.p;
    } catch (e) { /* privat läge eller blockerad lagring – hämta i stället */ }
    return null;
  }

  function direkt() {
    if (!karta) karta = lasCache();
    return karta;
  }

  function index() {
    if (direkt()) return Promise.resolve(karta);
    if (lopande) return lopande;
    lopande = fetch('/collections/all?view=kampanj', { credentials: 'same-origin' })
      .then(function (svar) { return svar.ok ? svar.text() : ''; })
      .then(function (text) {
        // Saknas alternativmallen (t.ex. i ett annat tema) kommer vanlig HTML tillbaka – då
        // finns inga kampanjpriser att visa, och det är rätt svar.
        var data = JSON.parse(text);
        karta = (data && data.produkter) || {};
        try { sessionStorage.setItem(NYCKEL, JSON.stringify({ t: Date.now(), p: karta })); } catch (e) {}
        return karta;
      })
      .catch(function () {
        lopande = null;
        return {};
      });
    return lopande;
  }

  window.WubsKampanj = { pris: pris, direkt: direkt, index: index };
})();
